export default __webpack_public_path__ + "static/media/1994.0f44aca5.png";